import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PostsApiService } from '../api/posts.service';
@Injectable({
  providedIn: 'root'
})

export class PostResolver implements Resolve<any> {
  constructor(
    private postService: PostsApiService,
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const postId = route.paramMap.get('post');
    const type = route.data['type'] || 'post';
    if (postId) {
      return this.postService.getPostDataById(postId, type);
    }
    return of(null);
  }
}
